import * as Types from './actions'

const initialState = {
    posts:[{ id:0,
        title: "Survival of the Richest",
        intro: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        category: "Tech",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
       },
       { id:1,
         title: "Complicating the Narratives",
         intro: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
         category: "Politics",
         content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
       },
       { id:2,
        title: "What is it Going to Take?",
        intro: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        category: "Tech",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
       },
       { id:3,
        title: "7 Basic Rules for Button Design",
        intro: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        category: "Design",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
       },
       { id:4,
        title: "The Top 5 Behavioural Economics Principles for Designers",
        intro: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        category: "Design",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
       },
       { id:5,
        title: "UX Case Study: Is there an app that can change the world?",
        intro: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        category: "Design",
        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
       },
     ],
}

const reducer = (state = initialState, action) => {
    switch (action.type){
        case Types.ADD_POST:
            return {posts: [...state.posts, action.data]}

        case Types.DEL_POST:
            const updatedArray = state.posts.filter(post=>
                post.id !== action.id
            )    
            return {posts: updatedArray}
        case Types.EDIT_POST:
            const editedArray = state.posts.map(post=>
                post.id === action.data.id
                  ? action.data
                  : post  
            )            
           return {posts: editedArray}
        default:
        return state;    
    }

}

export default reducer


// WEBPACK FOOTER //
// ./src/store/reducers/postsReducer.js